import { useCallback, useState } from "react"
import { talukaListApi } from "../api/taluka/talukaListApi"
import { Taluka } from "../entities/taluka"
import { useAuth } from "./useAuth"

export function useTalukaListApi(): {
	talukaList: Taluka[]
	isLoading: boolean
	error: null | Error
	fetchTalukaList: (filter?: Parameters<typeof talukaListApi>[0]) => Promise<void>
} {
	const { token } = useAuth()
	const [talukaList, setTalukaList] = useState<Taluka[]>([])
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState<Error | null>(null)

	const fetchTalukaList = useCallback(
		async (filter: Parameters<typeof talukaListApi>[0] = {}) => {
			try {
				setIsLoading(true)
				const data = await talukaListApi(filter, token)
				setTalukaList(data)
			} catch (error) {
				setError(error as Error)
			} finally {
				setIsLoading(false)
			}
		},
		[token],
	)

	return { talukaList, isLoading, error, fetchTalukaList }
}
